window.FroalaEditor = require("../../vendor/froala/js/froala_editor.pkgd.min.js");
require("../../vendor/froala/js/languages/tr.js");
require("../../vendor/froala/js/languages/de.js");
require("../../vendor/froala/js/languages/ru.js");

import Sortable from 'sortablejs/modular/sortable.complete.esm.js';

window.Sortable = Sortable;

require('@fancyapps/fancybox');

//Kumsal Script
window.Kumsal = require("./kumsal/kumsal-script.js");
require("./kumsal/kumsal-cropper.js");
require("./kumsal/kumsal-gallery.js");
require("./kumsal/kumsal-action.js");
require("./kumsal/kumsal-translation-selector.js");
require("./kumsal/kumsal-form-element.js");
require("./kumsal/kumsal-datatable.js");
require("./kumsal/kumsal-portlet.js");
require("./kumsal/kumsal-link.js");
require("./kumsal/kumsal-file.js");
require("./kumsal/kumsal-additional.js");
require("./kumsal/kumsal-panel.js");


import KumsalDashboard from './kumsal/kumsal-dashboard.js';

window.KumsalDashboard = KumsalDashboard;